import { INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_GET_REQUEST, INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_GET_SUCCESS } from '../actions/photoCaptureIntelligentDamageDetectionGetAction';
import { INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_GET_FAILURE, PHOTO_CAPTURE_RESET_CONTEXT } from '../actions';
export const photoCaptureIntelligentDamageDetectionGetReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_GET_REQUEST: {
            const existingIds = state.processedDamageDetectionRequestIds || [];
            // Deduplicate: only append if requestId not already in the list
            const requestId = action.payload.requestId;
            const processedIds = existingIds.includes(requestId) ? existingIds : [...existingIds, requestId];
            return Object.assign(Object.assign({}, state), { isLoading: true, processedDamageDetectionRequestIds: processedIds });
        }
        case INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_GET_SUCCESS:
            return Object.assign(Object.assign({}, state), { isLoading: false, damageDetectionData: action.payload.damageDetectionResponse });
        case INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_GET_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, failureMessage: action.payload.failureMessage });
        case PHOTO_CAPTURE_RESET_CONTEXT:
            return Object.assign(Object.assign({}, state), { processedDamageDetectionRequestIds: [] });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentDamageDetectionGetReducer.js.map